<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4 text-truncate">Add New Site {{ (inputName) ? (" - " + this.inputName) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4 text-truncate">View Site - {{this.inputName}}</h6>
        <h6 v-else class="heading-small text-muted mb-4 text-truncate">Edit Site - {{this.inputName}}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

       <b-tabs v-show="profileId != 0 && this.$attrs.viewMode == true" content-class="mt-3">
            <b-tab title="Details" active v-on:click="openDetails"></b-tab>
            <b-tab title="History" v-on:click="openHistory">
                <b><label>Created By: </label></b>
                {{inputCreatedBy || "System" }} | {{inputCreatedAt | dateFilter}}
                <br>
                <b><label>Updated By:</label></b>
                {{inputUpdatedBy || "System" }} | {{inputUpdatedAt | dateFilter}}
            </b-tab>
        </b-tabs>

        <form id="form-proper" v-show="showDetails">
            <!-- {{site}} -->
            <div v-if="customFormMode == 1">
                <a-tabs defaultActiveKey="1">
                    <a-tab-pane tab="Site" key="1">
                        <div class="form-group row">
                            <div class="col-sm-6">
                                <base-input alternative="" label="Code" disabled placeholder="" v-model="inputSiteCode" input-classes="form-control"/>
                            </div>
                            <div class="col-sm-6">
                                <base-input alternative="" label="ERP Code" disabled placeholder="" v-model="inputSiteErpCode" input-classes="form-control"/>
                            </div>
                        </div>
                        <base-input alternative="" label="Site Reference Code" placeholder="" v-model="inputCode" input-classes="form-control"/>
                        <base-input alternative="" label="Site Name" placeholder="" v-model="inputName" input-classes="form-control" required/>
                        <base-input label="Site Type" required>
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="siteTypeName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete
                                        :disableInput="isSiteTypeDisabled"
                                        ref="autocomplete"
                                        placeholder="Search Site Type"
                                        :source="siteTypeEndpoint"
                                        input-class="form-control"
                                        results-property="data"
                                        :results-display="formattedDisplay"
                                        :request-headers="authHeaders"
                                        @selected="getSiteType">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="Channel Type" required>
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="channelTypeName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete
                                        :disableInput="isChannelTypeDisabled"
                                        ref="autocomplete"
                                        placeholder="Search Channel"
                                        :source="channelTypeEndpoint"
                                        input-class="form-control"
                                        results-property="data"
                                        :results-display="formattedDisplay"
                                        :request-headers="authHeaders"
                                        @selected="getChannelType">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="Mall Group" required>
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="mallGroupName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete
                                        ref="autocomplete"
                                        placeholder="Search Mall Group"
                                        :source="mallGroupEndpoint"
                                        input-class="form-control"
                                        results-property="data"
                                        :results-display="formattedDisplay"
                                        :request-headers="authHeaders"
                                        @selected="getMallGroup">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="Mall" required>
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="mallName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete
                                        ref="autocomplete"
                                        placeholder="Search Mall"
                                        :source="mallEndpoint"
                                        input-class="form-control"
                                        results-property="data"
                                        :results-display="formattedDisplay"
                                        :request-headers="authHeaders"
                                        @selected="getMall">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="Store Owner" required>
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="companyName" disabled @change="setCompanyTin">
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete
                                        ref="autocomplete"
                                        placeholder="Search Company"
                                        :source="companyEndpoint"
                                        input-class="form-control"
                                        results-property="data"
                                        :results-display="formattedDisplay"
                                        :request-headers="authHeaders"
                                        @selected="getCompany">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="Site Concept" required>
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="siteConceptName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete
                                        ref="autocomplete"
                                        placeholder="Search Site Concept"
                                        :source="siteConceptEndpoint"
                                        input-class="form-control"
                                        results-property="data"
                                        :results-display="formattedDisplay"
                                        :request-headers="authHeaders"
                                        @selected="getSiteConcept">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="Store Category" required>
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="storeCategoryName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete
                                        ref="autocomplete"
                                        placeholder="Search Brand Category"
                                        :source="brandCategoryEndpoint"
                                        input-class="form-control"
                                        results-property="data"
                                        :results-display="formattedDisplay"
                                        :request-headers="authHeaders"
                                        @selected="getStoreCategory">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <hr>
                        <base-input required input-class="form-control" label="Country">
                            <a-select v-model="country_id" showSearch placeholder="Select Country" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="changeAddress('provinces')" :disabled="addressLoading == true">
                                <a-select-option v-for="option in countries" :key="option.code" :value="option.code">{{option.name}}</a-select-option>
                                </a-select>
                        </base-input>
                        <base-input required input-class="form-control" label="Province">
                            <a-select v-model="province_code" showSearch placeholder="Select Province" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="changeAddress('cities')" :disabled="addressLoading == true">
                                    <a-select-option v-for="option in addressOptions.provinces" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                            </a-select>
                        </base-input>

                        <base-input required input-class="form-control" label="City">
                            <a-select v-model="city_code" showSearch placeholder="Select City" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="changeAddress('barangays')" :disabled="addressLoading == true">
                                    <a-select-option v-for="option in addressOptions.cities" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                            </a-select>
                        </base-input>

                        <base-input required input-class="form-control" label="Barangay">
                            <a-select v-model="barangay_code" showSearch placeholder="Select Barangay" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="changeAddress('none')" :disabled="addressLoading == true">
                                <a-select-option v-for="option in addressOptions.barangays" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                            </a-select>
                        </base-input>
                        <base-input alternative="" label="Region" placeholder="" v-model="inputRegion" input-classes="form-control" />
                        <base-input required alternative="" label="Zip Code" placeholder="" v-model="inputZipCode" input-classes="form-control" />
                        <base-input label="Island" required>
                          <br>
                          <a-cascader v-model="inputLocation" :options="locationOptions" placeholder="All Locations" style="width: 100%" changeOnSelect />
                        </base-input>

                        <base-input required alternative="" label="Site Address 1" placeholder="" input-classes="form-control">
                            <textarea class="form-control" rows="4" v-model="inputAddress"></textarea>
                        </base-input>
                        <hr>
                        <base-input disabled alternative="" label="Store Age" placeholder="" v-model="inputSiteAge" input-classes="form-control" />
                        <!-- <base-input alternative="" label="Site Address 2" placeholder="" input-classes="form-control">
                            <textarea class="form-control" rows="4" v-model="inputAddress2"></textarea>
                        </base-input> -->
                        <!--  Contact Details-->
                        <base-input alternative="" label="TIN Number" placeholder="" v-model="inputTin" input-classes="form-control" required disabled/>
                        <base-input alternative="" label="TIN Branch Code" placeholder="" v-model="inputTinBranchCode" input-classes="form-control" required/>
                        <base-input alternative="" label="Landline Number" placeholder="" v-model="contactNumber" input-classes="form-control" />
                        <base-input alternative="" label="Telephone" placeholder="" v-model="telephone" input-classes="form-control" />
                        <base-input required alternative="" label="Viber Number" placeholder="" v-model="inputViberNumber" input-classes="form-control" />
                        <base-input label="Email" placeholder="" v-model="inputEmail" input-classes="form-control" type="email" name="inputEmail"/>

                        <base-input alternative="" label="Remark">
                            <textarea rows="4" class="form-control" v-model="inputRemark"/>
                        </base-input>
                        <hr><h4>Site Checklist</h4>
                        <base-checkbox class="mb-3" v-model="checkboxes.isRemote">
                            This is a Remote Site
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.isAllowedMergingSales">
                            Enable merged submission of sales and inventory to branch total
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.canDownloadPosInventory">
                            Enable Download for POS Inventory
                        </base-checkbox>
                        <!-- <base-checkbox class="mb-3" v-model="checkboxes.canDownloadPosSitePricing">
                            Enable Download for POS Site Pricing
                        </base-checkbox> -->
                        <!-- <base-checkbox class="mb-3" v-model="checkboxes.canDownloadTerminalSettings">
                            Enable the Download for Terminal Setting
                        </base-checkbox> -->
                        <base-checkbox class="mb-3" v-model="checkboxes.isStrickLotCodes">
                            Enable Strict Lot Codes in Back Office
                        </base-checkbox>
                        <!-- <base-checkbox class="mb-3" v-model="checkboxes.isSupportingZippedDocument" required>
                            Support Zipped Document
                        </base-checkbox> -->
                        <base-checkbox class="mb-3" v-model="checkboxes.isEnableEcomPos">
                            Enable Ecom POS
                        </base-checkbox>
                        <base-input label="Select Ecom Terminal" required v-if="checkboxes.isEnableEcomPos">
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="terminalName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete
                                        ref="autocomplete"
                                        placeholder="Search Terminal"
                                        :source="terminalEndpoint"
                                        input-class="form-control"
                                        results-property="data"
                                        :results-display="formattedDisplay"
                                        :request-headers="authHeaders"
                                        @selected="getTerminal">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-checkbox class="mb-3" v-model="checkboxes.isEnableSiteReplication" :disabled="disableReplication">
                            Replicate Site Master Data / Profiles
                        </base-checkbox>
                        <base-input label="Select Site" required v-if="checkboxes.isEnableSiteReplication">
                            <br/>
                            <span v-if="disableReplication">Site Replicated : {{this.inputReplicateSiteId}}</span>
                            <autocomplete
                                ref="autocomplete"
                                placeholder="Search Sites"
                                :source="sitesEndpoint"
                                :disable-input="disableReplication"
                                input-class="form-control"
                                results-property="data"
                                :results-display="formattedDisplay"
                                :request-headers="authHeaders"
                                @selected="getSite">
                            </autocomplete>
                        </base-input>

                        <br><br>
                        <base-input class="row">
                            <div class="col-md-10">
                                <h3>Site Reset</h3>
                                <h4>Reset this Site</h4>
                                <small>Flag this site to allow transaction reset. This will also tag all terminals under this site as for reset.</small>
                            </div>
                            <div class="float-right col-md-2">
                                <a-switch v-model="checkboxes.isEnableSiteReset"/>
                            </div>
                        </base-input>
                        <br><br>
                    </a-tab-pane>
                    <a-tab-pane :tab="profileId == 0 ? 'Salesman' : 'Sublocation & Salesman'" key="2" forceRender>
                        <div v-if="profileId == 0 || this.$attrs.viewMode == true">
                            <base-input v-if="this.$attrs.viewMode == true" alternative="" label="Code" placeholder="" v-model="inputSublocationCode" input-classes="form-control" disabled/>
                            <base-input v-if="this.$attrs.viewMode == true" alternative="" label="Name" placeholder="" v-model="inputSublocationName" input-classes="form-control" disabled/>
                            <base-input label="Type" v-if="this.$attrs.viewMode == true">
                                <select class="form-control form-control-sm" v-model="inputSublocationType" disabled v-if="this.$attrs.viewMode == true">
                                    <option v-for="option in sublocationTypeOptions" v-bind:value="option.key" v-bind:key="option.key" disabled>
                                        {{option.value}}
                                    </option>
                                </select>
                            </base-input>
                            <base-input label="Salesman">
                                <div class="form-group row">
                                    <div class="col-sm-6">
                                        <input type="text" class="form-control" v-model="salesmanName" disabled>
                                    </div>
                                    <div class="col-sm-6">
                                        <autocomplete
                                            ref="autocomplete"
                                            placeholder="Search Salesman"
                                            :source="salesmanEndpoint"
                                            input-class="form-control"
                                            results-property="data"
                                            :results-display="formattedDisplay"
                                            :request-headers="authHeaders"
                                            @selected="getSalesman">
                                        </autocomplete>
                                    </div>
                                </div>
                            </base-input>
                            <base-input alternative="" label="Description">
                                <textarea rows="4" class="form-control" v-model="inputDescription"/>
                            </base-input>
                            <base-input alternative="" label="Tags">
                                <textarea rows="4" class="form-control" v-model="inputTags"/>
                            </base-input>
                        </div>
                        <div v-else>
                            <base-input label="Sublocation">
                                <div class="form-group row">
                                    <div class="col-sm-6">
                                        <input type="text" class="form-control" v-model="sublocationName" disabled>
                                    </div>
                                    <div class="col-sm-6">
                                        <autocomplete
                                            ref="autocomplete"
                                            placeholder="Search Sublocation"
                                            :source="sublocationEndpoint"
                                            input-class="form-control"
                                            results-property="data"
                                            :results-display="formattedDisplay"
                                            :request-headers="authHeaders"
                                            @selected="getSublocation">
                                        </autocomplete>
                                    </div>
                                </div>
                            </base-input>
                            <base-input label="Salesman">
                                <div class="form-group row">
                                    <div class="col-sm-6">
                                        <input type="text" class="form-control" v-model="salesmanName" disabled>
                                    </div>
                                    <div class="col-sm-6">
                                        <autocomplete
                                            ref="autocomplete"
                                            placeholder="Search Salesman"
                                            :source="salesmanEndpoint"
                                            input-class="form-control"
                                            results-property="data"
                                            :results-display="formattedDisplay"
                                            :request-headers="authHeaders"
                                            @selected="getSalesman">
                                        </autocomplete>
                                    </div>
                                </div>
                            </base-input>
                            <base-input alternative="" label="Description">
                                <textarea rows="4" class="form-control" v-model="inputDescription"/>
                            </base-input>
                            <base-input alternative="" label="Tags">
                                <textarea rows="4" class="form-control" v-model="inputTags"/>
                            </base-input>
                        <br><br><br><br>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane tab="Other Details" key="3" forceRender>
                        <base-input label="Store Opening">
                            <div class="form-group row">
                                <div class="col-sm-12">
                                    <a-date-picker v-model='storeOpeningDate' placeholder="Store Opening" @change="calculateAge" style="width: 100%"/>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="Store Closure">
                            <div class="form-group row">
                                <div class="col-sm-12">
                                    <a-date-picker v-model='storeClosureDate' placeholder="Store Closure" @change="calculateAge" style="width: 100%"/>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="Contract Start Date">
                            <div class="form-group row">
                                <div class="col-sm-12">
                                    <a-date-picker v-model='contractStartDate' placeholder="Contract Start Date" style="width: 100%"/>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="Contract End Date">
                            <div class="form-group row">
                                <div class="col-sm-12">
                                    <a-date-picker v-model='contractEndDate' placeholder="Contract End Date" style="width: 100%"/>
                                </div>
                            </div>
                        </base-input>
                        <hr>
                        <base-input alternative="" label="SQM" placeholder="" v-model="inputSqm" input-classes="form-control"/>
                        <!-- <base-input alternative="" label="Lessor" placeholder="" v-model="inputLessor" input-classes="form-control"/> -->
                        <base-input label="Lessor">
                            <a-select showSearch
                            v-model="inputLessor"
                            style="width: 100%" placeholder="Please select"
                            :filterOption="false"
                            :notFoundContent="fetching ? undefined : null"
                            :disabled="viewMode"
                            @search="handleB2bCustomerSearch"
                            @focus="handleB2bCustomerSearch"
                            >
                                <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                                <a-select-option v-for="option in b2bCustomersList" :key="option.id" :value="option.id">{{"("+option.code+") "+option.name}}</a-select-option>
                            </a-select>
                        </base-input>
                        
                        <base-input alternative="" label="Rent Arrangement" placeholder="" v-model="inputRentArrangement" input-classes="form-control"/>
                        <base-input alternative="" label="Basic Rent (Per SQM)" placeholder="" v-model="inputBasicRentPerSqm" input-classes="form-control" />
                        <base-input alternative="" label="Mall Commission (%)" placeholder="" v-model="inputMallCommission" input-classes="form-control" />
                        <base-input alternative="" label="MGR" placeholder="" v-model="inputMgr" input-classes="form-control" />
                        <base-input alternative="" label="CUSA" placeholder="" v-model="inputCusa" input-classes="form-control" />
                        <base-input alternative="" label="AIRCON" placeholder="" v-model="inputAircon" input-classes="form-control" />
			            <base-input alternative="" label="Contract Link" placeholder="" v-model="inputContactLink" input-classes="form-control" />
                        <base-input alternative="" label="Security Deposit" placeholder="" v-model="inputSecurityDeposit" input-classes="form-control" />
                        <base-input alternative="" label="Nav Store Code" placeholder="" v-model="inputNavStoreCode" input-classes="form-control" />
                        <base-input alternative="" label="Construction Bond" placeholder="" v-model="inputConstructionBond" input-classes="form-control" />
                        <hr>
                        <!-- <base-input alternative="" label="Regional Sales Head">
                            <a-select v-model="inputStoreHead1" showSearch placeholder="Regional Sales Head" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                <a-select-option v-for="option in store_heads" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                            </a-select>
                        </base-input> -->
                        <base-input alternative="" label="Regional Sales Head" placeholder="" v-model="inputRegionalHead" input-classes="form-control"/>
                        <base-input label="Start Date">
                            <div class="form-group row">
                                <div class="col-sm-12">
                                    <a-date-picker v-model='sh1EffectivityStartDate' placeholder="Start Date" style="width: 100%"/>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="End Date">
                            <div class="form-group row">
                                <div class="col-sm-12">
                                    <a-date-picker v-model='sh1EffectivityEndDate' placeholder="Start Date" style="width: 100%"/>
                                </div>
                            </div>
                        </base-input>
                        <!-- <base-input alternative="" label="Area Manager">
                            <a-select v-model="inputStoreHead2" showSearch placeholder="Area Manager" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                <a-select-option v-for="option in store_heads" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                            </a-select>
                        </base-input> -->
                        <base-input alternative="" label="Area Manager" placeholder="" v-model="inputAreaHead" input-classes="form-control"/>
                        <base-input label="Start Date">
                            <div class="form-group row">
                                <div class="col-sm-12">
                                    <a-date-picker v-model='sh2EffectivityStartDate' placeholder="Start Date" style="width: 100%"/>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="End Date">
                            <div class="form-group row">
                                <div class="col-sm-12">
                                    <a-date-picker v-model='sh2EffectivityEndDate' placeholder="Start Date" style="width: 100%"/>
                                </div>
                            </div>
                        </base-input>
                        <!-- <base-input alternative="" label="Cluster Leader">
                            <a-select v-model="inputStoreHead3" showSearch placeholder="Cluster Leader" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                <a-select-option v-for="option in store_heads" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                            </a-select>
                        </base-input> -->
                        <!-- Hide Cluster Leader
                            <base-input alternative="" label="Cluster Leader" placeholder="" v-model="inputStoreHead3" input-classes="form-control"/>
                        <base-input label="Start Date" required>
                            <div class="form-group row">
                                <div class="col-sm-12">
                                    <a-date-picker v-model='sh3EffectivityStartDate' placeholder="Start Date" style="width: 100%"/>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="End Date" required>
                            <div class="form-group row">
                                <div class="col-sm-12">
                                    <a-date-picker v-model='sh3EffectivityEndDate' placeholder="Start Date" style="width: 100%"/>
                                </div>
                            </div>
                        </base-input>
                        -->
                    </a-tab-pane>
                </a-tabs>
            </div>
            <div v-if="customFormMode == 2">
                <!-- Override -->
                <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups}" :formSettings="this.site" @valueUpdated="updateSettings" :key="dynamicFormKey"/>
            </div>
            <div v-if="customFormMode == 3">
                <!-- Append -->
                <a-tabs defaultActiveKey="1">
                    <a-tab-pane tab="Site" key="1">
                        <div class="form-group row">
                            <div class="col-sm-6">
                                <base-input alternative="" label="Code" disabled placeholder="" v-model="inputSiteCode" input-classes="form-control"/>
                            </div>
                            <div class="col-sm-6">
                                <base-input alternative="" label="ERP Code" disabled placeholder="" v-model="inputSiteErpCode" input-classes="form-control"/>
                            </div>
                        </div>
                        <!-- <base-input alternative="" label="Code" disabled placeholder="" v-model="inputSiteCode" input-classes="form-control"/> -->
                        <base-input alternative="" label="Site Reference Code" placeholder="" v-model="inputCode" input-classes="form-control"/>
                        <base-input alternative="" label="Site Name" placeholder="" v-model="inputName" input-classes="form-control" required/>
                        <base-input label="Site Type" required>
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="siteTypeName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete
                                        :disableInput="isSiteTypeDisabled"
                                        ref="autocomplete"
                                        placeholder="Search Site Type"
                                        :source="siteTypeEndpoint"
                                        input-class="form-control"
                                        results-property="data"
                                        :results-display="formattedDisplay"
                                        :request-headers="authHeaders"
                                        @selected="getSiteType">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="Channel Type">
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="channelTypeName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete
                                        :disableInput="isChannelTypeDisabled"
                                        ref="autocomplete"
                                        placeholder="Search Channel"
                                        :source="channelTypeEndpoint"
                                        input-class="form-control"
                                        results-property="data"
                                        :results-display="formattedDisplay"
                                        :request-headers="authHeaders"
                                        @selected="getChannelType">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="Mall Group" required>
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="mallGroupName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete
                                        ref="autocomplete"
                                        placeholder="Search Mall Group"
                                        :source="mallGroupEndpoint"
                                        input-class="form-control"
                                        results-property="data"
                                        :results-display="formattedDisplay"
                                        :request-headers="authHeaders"
                                        @selected="getMallGroup">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="Mall" required>
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="mallName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete
                                        ref="autocomplete"
                                        placeholder="Search Mall"
                                        :source="mallEndpoint"
                                        input-class="form-control"
                                        results-property="data"
                                        :results-display="formattedDisplay"
                                        :request-headers="authHeaders"
                                        @selected="getMall">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="Store Owner" required>
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="companyName" disabled @change="setCompanyTin">
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete
                                        ref="autocomplete"
                                        placeholder="Search Company"
                                        :source="companyEndpoint"
                                        input-class="form-control"
                                        results-property="data"
                                        :results-display="formattedDisplay"
                                        :request-headers="authHeaders"
                                        @selected="getCompany">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="Site Concept" required>
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="siteConceptName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete
                                        ref="autocomplete"
                                        placeholder="Search Site Concept"
                                        :source="siteConceptEndpoint"
                                        input-class="form-control"
                                        results-property="data"
                                        :results-display="formattedDisplay"
                                        :request-headers="authHeaders"
                                        @selected="getSiteConcept">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="Store Brand Category" required>
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="storeCategoryName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete
                                        ref="autocomplete"
                                        placeholder="Search Brand Category"
                                        :source="brandCategoryEndpoint"
                                        input-class="form-control"
                                        results-property="data"
                                        :results-display="formattedDisplay"
                                        :request-headers="authHeaders"
                                        @selected="getStoreCategory">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <hr>
                        <base-input required input-class="form-control" label="Country">
                            <a-select v-model="country_id" showSearch placeholder="Select Country" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="changeAddress('provinces')" :disabled="addressLoading == true">
                                <a-select-option v-for="option in countries" :key="option.code" :value="option.code">{{option.name}}</a-select-option>
                                </a-select>
                        </base-input>
                        <base-input required input-class="form-control" label="Province">
                            <a-select v-model="province_code" showSearch placeholder="Select Province" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="changeAddress('cities')" :disabled="addressLoading == true">
                                    <a-select-option v-for="option in addressOptions.provinces" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                            </a-select>
                        </base-input>

                        <base-input required input-class="form-control" label="City">
                            <a-select v-model="city_code" showSearch placeholder="Select City" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="changeAddress('barangays')" :disabled="addressLoading == true">
                                    <a-select-option v-for="option in addressOptions.cities" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                            </a-select>
                        </base-input>

                        <base-input input-class="form-control" label="Barangay">
                            <a-select v-model="barangay_code" showSearch placeholder="Select Barangay" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="changeAddress('none')" :disabled="addressLoading == true">
                                <a-select-option v-for="option in addressOptions.barangays" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                            </a-select>
                        </base-input>
                        <base-input alternative="" label="Region" placeholder="" v-model="inputRegion" input-classes="form-control" />
                        <base-input required alternative="" label="Zip Code" placeholder="" v-model="inputZipCode" input-classes="form-control" />
                        <base-input label="Island">
                          <br>
                          <a-cascader v-model="inputLocation" :options="locationOptions" placeholder="All Locations" style="width: 100%" changeOnSelect />
                        </base-input>

                        <base-input required alternative="" label="Site Address 1" placeholder="" input-classes="form-control">
                            <textarea class="form-control" rows="4" v-model="inputAddress"></textarea>
                        </base-input>
                        <hr>
                        <base-input disabled alternative="" label="Store Age" placeholder="" v-model="inputSiteAge" input-classes="form-control" />
                        <!-- <base-input alternative="" label="Site Address 2" placeholder="" input-classes="form-control">
                            <textarea class="form-control" rows="4" v-model="inputAddress2"></textarea>
                        </base-input> -->
                        <!--  Contact Details-->
                        <base-input alternative="" label="TIN Number" placeholder="" v-model="inputTin" input-classes="form-control" required/>
                        <base-input alternative="" label="TIN Branch Code" placeholder="" v-model="inputTinBranchCode" input-classes="form-control" required/>
                        <base-input alternative="" label="Landline Number" placeholder="" v-model="contactNumber" input-classes="form-control" />
                        <base-input required alternative="" label="Telephone" placeholder="" v-model="telephone" input-classes="form-control" />
                        <base-input required alternative="" label="Viber Number" placeholder="" v-model="inputViberNumber" input-classes="form-control" />
                        <base-input label="Email" placeholder="" v-model="inputEmail" input-classes="form-control" type="email" name="inputEmail"/>

                        <base-input alternative="" label="Remark">
                            <textarea rows="4" class="form-control" v-model="inputRemark"/>
                        </base-input>
                        <hr><h4>Site Checklist</h4>
                        <base-checkbox class="mb-3" v-model="checkboxes.isRemote">
                            This is a Remote Site
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.isAllowedMergingSales">
                            Enable merged submission of sales and inventory to branch total
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.canDownloadPosInventory">
                            Enable Download for POS Inventory
                        </base-checkbox>
                        <!-- <base-checkbox class="mb-3" v-model="checkboxes.canDownloadPosSitePricing">
                            Enable Download for POS Site Pricing
                        </base-checkbox> -->
                        <!-- <base-checkbox class="mb-3" v-model="checkboxes.canDownloadTerminalSettings">
                            Enable the Download for Terminal Setting
                        </base-checkbox> -->
                        <base-checkbox class="mb-3" v-model="checkboxes.isStrickLotCodes">
                            Enable Strict Lot Codes in Back Office
                        </base-checkbox>
                        <!-- <base-checkbox class="mb-3" v-model="checkboxes.isSupportingZippedDocument" required>
                            Support Zipped Document
                        </base-checkbox> -->
                        <base-checkbox class="mb-3" v-model="checkboxes.isEnableEcomPos">
                            Enable Ecom POS
                        </base-checkbox>
                        <base-input label="Select Ecom Terminal" required v-if="checkboxes.isEnableEcomPos">
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="terminalName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete
                                        ref="autocomplete"
                                        placeholder="Search Terminal"
                                        :source="terminalEndpoint"
                                        input-class="form-control"
                                        results-property="data"
                                        :results-display="formattedDisplay"
                                        :request-headers="authHeaders"
                                        @selected="getTerminal">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-checkbox class="mb-3" v-model="checkboxes.isEnableSiteReplication" :disabled="disableReplication">
                            Replicate Site Master Data / Profiles
                        </base-checkbox>
                        <base-input label="Select Site" required v-if="checkboxes.isEnableSiteReplication">
                            <br/>
                            <span v-if="disableReplication">Site Replicated : {{this.inputReplicateSiteId}}</span>
                            <autocomplete
                                ref="autocomplete"
                                placeholder="Search Sites"
                                :source="sitesEndpoint"
                                :disable-input="disableReplication"
                                input-class="form-control"
                                results-property="data"
                                :results-display="formattedDisplay"
                                :request-headers="authHeaders"
                                @selected="getSite">
                            </autocomplete>
                        </base-input>

                        <br><br>
                        <base-input class="row">
                            <div class="col-md-10">
                                <h3>Site Reset</h3>
                                <h4>Reset this Site</h4>
                                <small>Flag this site to allow transaction reset. This will also tag all terminals under this site as for reset.</small>
                            </div>
                            <div class="float-right col-md-2">
                                <a-switch v-model="checkboxes.isEnableSiteReset"/>
                            </div>
                        </base-input>
                        <br><br>
                    </a-tab-pane>
                    <a-tab-pane :tab="profileId == 0 ? 'Salesman' : 'Sublocation & Salesman'" key="2" forceRender>
                        <div v-if="profileId == 0 || this.$attrs.viewMode == true">
                            <base-input v-if="this.$attrs.viewMode == true" alternative="" label="Code" placeholder="" v-model="inputSublocationCode" input-classes="form-control" disabled/>
                            <base-input v-if="this.$attrs.viewMode == true" alternative="" label="Name" placeholder="" v-model="inputSublocationName" input-classes="form-control" disabled/>
                            <base-input label="Type" v-if="this.$attrs.viewMode == true">
                                <select class="form-control form-control-sm" v-model="inputSublocationType" disabled v-if="this.$attrs.viewMode == true">
                                    <option v-for="option in sublocationTypeOptions" v-bind:value="option.key" v-bind:key="option.key" disabled>
                                        {{option.value}}
                                    </option>
                                </select>
                            </base-input>
                            <base-input label="Salesman">
                                <div class="form-group row">
                                    <div class="col-sm-6">
                                        <input type="text" class="form-control" v-model="salesmanName" disabled>
                                    </div>
                                    <div class="col-sm-6">
                                        <autocomplete
                                            ref="autocomplete"
                                            placeholder="Search Salesman"
                                            :source="salesmanEndpoint"
                                            input-class="form-control"
                                            results-property="data"
                                            :results-display="formattedDisplay"
                                            :request-headers="authHeaders"
                                            @selected="getSalesman">
                                        </autocomplete>
                                    </div>
                                </div>
                            </base-input>
                            <base-input alternative="" label="Description">
                                <textarea rows="4" class="form-control" v-model="inputDescription"/>
                            </base-input>
                            <base-input alternative="" label="Tags">
                                <textarea rows="4" class="form-control" v-model="inputTags"/>
                            </base-input>
                        </div>
                        <div v-else>
                            <base-input label="Sublocation">
                                <div class="form-group row">
                                    <div class="col-sm-6">
                                        <input type="text" class="form-control" v-model="sublocationName" disabled>
                                    </div>
                                    <div class="col-sm-6">
                                        <autocomplete
                                            ref="autocomplete"
                                            placeholder="Search Sublocation"
                                            :source="sublocationEndpoint"
                                            input-class="form-control"
                                            results-property="data"
                                            :results-display="formattedDisplay"
                                            :request-headers="authHeaders"
                                            @selected="getSublocation">
                                        </autocomplete>
                                    </div>
                                </div>
                            </base-input>
                        <br><br><br><br>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane tab="Other Details" key="3" forceRender>
                        <base-input label="Store Opening">
                            <div class="form-group row">
                                <div class="col-sm-12">
                                    <a-date-picker v-model='storeOpeningDate' placeholder="Store Opening" style="width: 100%"/>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="Store Closure">
                            <div class="form-group row">
                                <div class="col-sm-12">
                                    <a-date-picker v-model='storeClosureDate' placeholder="Store Closure" style="width: 100%"/>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="Contract Start Date">
                            <div class="form-group row">
                                <div class="col-sm-12">
                                    <a-date-picker v-model='contractStartDate' placeholder="Contract Start Date" style="width: 100%"/>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="Contract End Date">
                            <div class="form-group row">
                                <div class="col-sm-12">
                                    <a-date-picker v-model='contractEndDate' placeholder="Contract End Date" style="width: 100%"/>
                                </div>
                            </div>
                        </base-input>
                        <hr>
                        <base-input alternative="" label="SQM" placeholder="" v-model="inputSqm" input-classes="form-control"/>
                        <base-input alternative="" label="Lessor" placeholder="" v-model="inputLessor" input-classes="form-control"/>
                        <base-input alternative="" label="Rent Arrangement" placeholder="" v-model="inputRentArrangement" input-classes="form-control"/>
                        <base-input alternative="" label="Basic Rent (Per SQM)" placeholder="" v-model="inputBasicRentPerSqm" input-classes="form-control" />
                        <base-input alternative="" label="Mall Commission (%)" placeholder="" v-model="inputMallCommission" input-classes="form-control" />
                        <base-input alternative="" label="MGR" placeholder="" v-model="inputMgr" input-classes="form-control" />
                        <base-input alternative="" label="CUSA" placeholder="" v-model="inputCusa" input-classes="form-control" />
                        <base-input alternative="" label="AIRCON" placeholder="" v-model="inputAircon" input-classes="form-control" />
			            <base-input alternative="" label="Contract Link" placeholder="" v-model="inputContactLink" input-classes="form-control" />
                        <base-input alternative="" label="Security Deposit" placeholder="" v-model="inputSecurityDeposit" input-classes="form-control" />
                        <base-input alternative="" label="Nav Store Code" placeholder="" v-model="inputNavStoreCode" input-classes="form-control" />
                        <base-input alternative="" label="Construction Bond" placeholder="" v-model="inputConstructionBond" input-classes="form-control" />
                        <hr>
                        <!-- <base-input alternative="" label="Regional Sales Head">
                            <a-select v-model="inputStoreHead1" showSearch placeholder="Regional Sales Head" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                <a-select-option v-for="option in store_heads" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                            </a-select>
                        </base-input> -->
                        <base-input alternative="" label="Regional Sales Head" placeholder="" v-model="inputRegionalHead" input-classes="form-control"/>
                        <base-input label="Start Date">
                            <div class="form-group row">
                                <div class="col-sm-12">
                                    <a-date-picker v-model='sh1EffectivityStartDate' placeholder="Start Date" style="width: 100%"/>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="End Date">
                            <div class="form-group row">
                                <div class="col-sm-12">
                                    <a-date-picker v-model='sh1EffectivityEndDate' placeholder="Start Date" style="width: 100%"/>
                                </div>
                            </div>
                        </base-input>
                        <!-- <base-input alternative="" label="Area Manager">
                            <a-select v-model="inputStoreHead2" showSearch placeholder="Area Manager" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                <a-select-option v-for="option in store_heads" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                            </a-select>
                        </base-input> -->
                        <base-input alternative="" label="Area Manager" placeholder="" v-model="inputAreaHead" input-classes="form-control"/>
                        <base-input label="Start Date" required>
                            <div class="form-group row">
                                <div class="col-sm-12">
                                    <a-date-picker v-model='sh2EffectivityStartDate' placeholder="Start Date" style="width: 100%"/>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="End Date" required>
                            <div class="form-group row">
                                <div class="col-sm-12">
                                    <a-date-picker v-model='sh2EffectivityEndDate' placeholder="Start Date" style="width: 100%"/>
                                </div>
                            </div>
                        </base-input>
                        <!-- <base-input alternative="" label="Cluster Leader">
                            <a-select v-model="inputStoreHead3" showSearch placeholder="Cluster Leader" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                <a-select-option v-for="option in store_heads" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                            </a-select>
                        </base-input> -->
                        <!-- Hide Cluster Leader
                            <base-input alternative="" label="Cluster Leader" placeholder="" v-model="inputStoreHead3" input-classes="form-control"/>
                        <base-input label="Start Date" required>
                            <div class="form-group row">
                                <div class="col-sm-12">
                                    <a-date-picker v-model='sh3EffectivityStartDate' placeholder="Start Date" style="width: 100%"/>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="End Date" required>
                            <div class="form-group row">
                                <div class="col-sm-12">
                                    <a-date-picker v-model='sh3EffectivityEndDate' placeholder="Start Date" style="width: 100%"/>
                                </div>
                            </div>
                        </base-input>
                        -->
                    </a-tab-pane>
                    <a-tab-pane tab="Custom Fields" key="4" forceRender>
                        <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups_append}" :formSettings="this.site" @valueUpdated="updateSettings" :key="dynamicFormKey" :showErrors="false"/>
                    </a-tab-pane>
                </a-tabs>
            </div>

            <div class='mt-5' v-if="this.$attrs.viewMode != true">
                <div v-if="serverType == 'ho'" style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Add</button>
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button>
                </div>
                <div v-else style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button>
                </div>
            </div>
        </form>
    </div>
</template>


<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import DynamicForm from '../DynamicForm.vue'
import secureStorage from '../../controllers/secureStorage.js'
import ValidateField from '../../components/validateFormUtils.js'
import { mapState } from 'vuex'
import Autocomplete from 'vuejs-auto-complete'
import moment from 'moment'
var component_x;
export default {
    components: {
        Autocomplete, DynamicForm
    },
    computed: {
        ...mapState(['endPoint', 'profileId', 'serverType']),
    },
    mounted: async function() {
        // Meta-data Call
        const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Site?field_name=name'  , null)
        const sytemModuleId = sytemModule.id
        const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId + '?field_name=system_module_id'  , null)

        //Get Countries
        var countries = await HTTPRequest.getRequest(this.endPoint + "countries" , null, null)
        this.countries = countries.data

        // this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view'  , null)
        this.locationOptions = this.$attrs.locationOptions

        if(this.isJsonString(accSystemModuleRequest.meta) == true){
            const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
            if(accSystemModule != null){
                if(accSystemModule.form_mode != undefined){
                    this.customFormMode = accSystemModule.form_mode
                }
                if(accSystemModule.customized_forms != undefined){
                    this.customForm = accSystemModule.customized_forms
                }
            }
        }

        if(this.serverType == 'branch' || this.$attrs.viewMode == true){
            var form = document.getElementById("form-proper")
            var elements = form.elements;
            for (var i = 0, len = elements.length; i < len; ++i) {
                elements[i].disabled = true;
            }
        }
        component_x = this

        //Get Store Heads
        var store_heads = await HTTPRequest.getRequest(component_x.endPoint + 'users/get_user_group_users?group=STORE HEADS', null)
        this.store_heads = store_heads['users']

        //Get Area Heads
        var area_heads = await HTTPRequest.getRequest(component_x.endPoint + 'users/get_user_group_users?group=AREA HEADS', null)
        this.area_heads = area_heads['users']

        //Get Regional Heads
        var regional_heads = await HTTPRequest.getRequest(component_x.endPoint + 'users/get_user_group_users?group=REGIONAL HEADS', null)
        this.regional_heads = regional_heads['users']

        if( component_x.profileId > 0){
            var data = await HTTPRequest.getRequest(component_x.endPoint + 'sites/' + component_x.profileId, null)
            console.log('991',data["location_path"])
            if(data == undefined){
                component_x.$router.go()
            } else {
                if(data["error"] == undefined){
                    component_x.inputCode = data["refcode"]
                    component_x.inputSiteCode = data["code"]
                    component_x.inputSiteErpCode = data["erp_code"]
                    this.site = data
                    if(data["location_path"] != null) component_x.inputLocation = JSON.parse(data["location_path"])
                    component_x.inputName = data["name"]
                    component_x.contactPerson = data["contact_person"]
                    component_x.contactNumber = data["landline_number"]
                    component_x.telephone = data["telephone"]
                    component_x.inputSiteType = data["site_type_id"]
                    component_x.inputChannelType = data["channel_type_id"]
                    component_x.inputMallGroup = data["mall_group_id"]
                    component_x.inputMall = data["mall_id"]
                    component_x.inputCountry = data["country_id"]
                    component_x.inputCompany = data["company_id"]
                    component_x.inputSiteConcept = data["site_concept_id"]
                    component_x.inputStoreCategory = data["store_category_id"]
                    component_x.inputTin = data["tin"]
                    component_x.inputTinBranchCode = data["tin_branch_code"]
                    component_x.ipAddress = data["ip_address"]
                    component_x.inputRemark = data["remark"]
                    component_x.inputCreatedBy = data["created_by"]
                    component_x.inputCreatedAt = data["created_at"]
                    component_x.inputUpdatedBy = data["updated_by"]
                    component_x.inputUpdatedAt = data["updated_at"]
                    component_x.checkboxes.isRemote = data["is_remote"]
                    component_x.companyName = data["company_name"]
                    component_x.siteConceptName = data["site_concept_name"]
                    component_x.storeCategoryName = data["store_category_name"]
                    component_x.siteTypeName = data["site_type"]
                    component_x.channelTypeName = data["channel_type_name"]
                    component_x.mallGroupName = data["mall_group"]
                    component_x.mallName = data["mall"]
                    // component_x.countryName = data["country"]
                    component_x.inputSqm= data["measurement"]
                    component_x.storeOpeningDate= data["opening_date"]
                    component_x.storeClosureDate= data["closure_date"]
                    component_x.contractStartDate= data["contract_start_date"]
                    component_x.contractEndDate= data["contract_end_date"]
                    component_x.inputAddress = data["address_1"]
                    component_x.inputAddress2= data["address_2"]
                    component_x.inputBasicRentPerSqm= data["basic_rent_per_sqm"]
                    component_x.inputMallCommission= data["mall_commission"]
                    component_x.inputMgr= data["mgr"]
                    component_x.inputCusa= data["cusa"]
                    component_x.inputAircon= data["aircon"]
                    component_x.inputContactLink= data["contract_link"]
                    component_x.inputTelcoProvider= data["telco_provider"]
                    component_x.inputInternetProvider= data["internet_provider"]
                    component_x.inputViberNumber= data["viber_number"]
                    component_x.inputSecDep= data["sec_dep"]
                    component_x.inputSiteAge= '0 Year, 0 Month, 0 Day'
                    component_x.inputAreaHead= data["area_leader"]
                    component_x.inputRegionalHead= data["regional_sales_head"]
                    component_x.inputStoreHead1= data["store_head1_id"]
                    component_x.sh1EffectivityStartDate= data["sh1_effectivity_start_date"]
                    component_x.sh1EffectivityEndDate= data["sh1_effectivity_end_date"]
                    component_x.inputStoreHead2= data["store_head2_id"]
                    component_x.sh2EffectivityStartDate= data["sh2_effectivity_start_date"]
                    component_x.sh2EffectivityEndDate= data["sh2_effectivity_end_date"]
                    component_x.inputStoreHead3= data["store_head3_id"]
                    component_x.sh3EffectivityStartDate= data["sh3_effectivity_start_date"]
                    component_x.sh3EffectivityEndDate= data["sh3_effectivity_end_date"]
                    component_x.inputSiteQuota= data["site_quota"]
                    component_x.inputCity= data["city"]
                    component_x.inputZipCode= data["zip_code"]
                    component_x.inputRegion= data["region"]
                    
                    component_x.inputRentArrangement= data["rent_arrangement"]
                    component_x.inputSecurityDeposit= data["security_deposit"]
                    component_x.inputNavStoreCode= data["nav_store_code"]
                    component_x.inputConstructionBond= data["construction_bond"]
                    component_x.province_code= data["province_code"]
                    component_x.province_name= data["province_name"]
                    component_x.city_code= data["city_code"]
                    component_x.city_name= data["city_name"]
                    component_x.barangay_code= data["barangay_code"]
                    component_x.barangay_name= data["barangay_name"]
                    component_x.zip_code= data["zip_code"]
                    component_x.country_id= data["country_id"]
                    //component_x.inputLessor= parseInt(data["lessor"]) || ''

                    var b2bCustomersList = await HTTPRequest.getRequest(this.endPoint + "b2b_customers/" + data["lessor"] , null, null)
                    component_x.b2bCustomersList = b2bCustomersList.data

                    component_x.lessor_id= parseInt(data["lessor"]) || ''
                    component_x.inputLessor = data["lessor_name"] || ''
                    
                    //var countries = await HTTPRequest.getRequest(this.endPoint + "countries?code=" + component_x.country_id , null, null)
                    //this.countries = countries.data
                    await this.changeAddress('provinces', 1);
                    await this.changeAddress('cities', 1);
                    await this.changeAddress('barangays', 1);

                    if(data["opening_date"] != null && data["closure_date"] == null && (data["site_age"]==null || data["site_age"]=="")) {
                        const date1 = new Date(Date.now());
                        const date2 = new Date(data["opening_date"]);
                        component_x.inputSiteAge = this.getFormattedAgeDifference(date2, date1);
                    } else if(data["opening_date"] != null && data["closure_date"] != null && (data["site_age"]==null || data["site_age"]=="")) {
                        const date1 = new Date(data["closure_date"]);
                        const date2 = new Date(data["opening_date"]);
                        component_x.inputSiteAge = this.getFormattedAgeDifference(date2, date1);
                    } else {
                        if (data["site_age"]!=null){
                            component_x.inputSiteAge = data["site_age"]
                        }else{
                            component_x.inputSiteAge = '0 Year, 0 Month, 0 Day'
                        }
                    }
                    component_x.checkboxes.isAllowedMergingSales = data["is_allowed_merging_sales"]
                    component_x.checkboxes.canDownloadPosInventory = data["can_download_pos_inventory"]
                    component_x.checkboxes.isEnableSiteReset = data["is_for_resetting"]
                    // component_x.checkboxes.canDownloadPosSitePricing = data["can_download_pos_site_pricing"]
                    // component_x.checkboxes.canDownloadTerminalSettings = data["can_download_terminal_settings"]
                    component_x.checkboxes.isStrickLotCodes = data["is_strick_lot_codes"]
                    // component_x.checkboxes.isSupportingZippedDocument = data["is_supporting_zipped_document"]
                    component_x.checkboxes.isEnableEcomPos = data["ecomm_terminal_id"]!= undefined && data["ecomm_terminal_id"]!= null ? true : false
                    component_x.terminalName = data["terminal_name"]
                    component_x.inputTerminal = data["ecomm_terminal_id"]
                    component_x.disableReplication = data["replicated_site_id"]!= undefined && data["replicated_site_id"]!= null ? true : false
                    component_x.checkboxes.isEnableSiteReplication = data["replicated_site_id"]!= undefined && data["replicated_site_id"]!= null ? true : false
                    component_x.inputReplicateSiteId = data["replicated_site_id"]
                    component_x.inputEmail = data["email"]


                    if (data["serialized_sublocation"]) {
                        component_x.inputSublocationCode = data["serialized_sublocation"]["code"]
                        component_x.inputSublocationName = data["serialized_sublocation"]["name"]
                        component_x.inputSublocationType = data["serialized_sublocation"]["sublocation_type"]
                        component_x.inputSalesman = data["serialized_sublocation"]["salesman_id"]
                        component_x.salesmanName = data["serialized_sublocation"]["salesman_name"]
                        component_x.inputDescription = data["serialized_sublocation"]["description"]
                        component_x.inputTags = data["serialized_sublocation"]["tags"]
                        component_x.inputSublocation = data["serialized_sublocation"]["id"]
                        component_x.sublocationName = data["serialized_sublocation"]["name"]
                    }
                } else {
                    this.errors = data["error"].split(",") //format will change when error message has comma
                    //component_x.$router.push("/")
                }
            }
        }

        this.dynamicFormKey++;
    },
    data: function(){
        return {
            lessor_id: 0,
            viewMode: false,
            // searchable select
             fetching: false,
            // Location Implem
            b2bCustomersList: [],
            site_type: '',
            store_heads: [],
            area_heads: [],
            regional_heads: [],
            date: '',
            inputLocation: null,
            locationOptions: [],
            inputSiteCode: '',
            inputSiteErpCode:'',
            inputCode: '',
            inputName: '',
            inputSiteType: '',
            inputMallGroup: '',
            inputMall: '',
            inputCountry: '',
            inputSqm: '',
            storeOpeningDate: '',
            storeClosureDate: '',
            contractStartDate: '',
            contractEndDate: '',
            inputAddress2: '',
            inputBasicRentPerSqm: '',
            inputMallCommission: '',
            inputMgr: '',
            inputCusa: '',
            inputAircon: '',
            inputContactLink: '',
            inputTelcoProvider: '',
            inputInternetProvider: '',
            inputViberNumber: '',
            inputSecDep: '',
            inputSiteAge: '',
            isSiteTypeDisabled: false,
            isChannelTypeDisabled: false,
            siteTypeName: '',
            channelTypeName: '',
            mallGroupName: '',
            mallName: '',
            // countryName: '',
            inputCompany: '',
            companyName: '',
            inputSiteConcept: '',
            siteConceptName: '',
            inputStoreCategory: '',
            storeCategoryName: '',
            inputTin: '',
            inputTinBranchCode: '',
            inputAddress: '',
            inputAreaHead: '',
            inputRegionalHead: '',
            inputStoreHead1: '',
            sh1EffectivityStartDate: '',
            sh1EffectivityEndDate: '',
            inputStoreHead2: '',
            sh2EffectivityStartDate: '',
            sh2EffectivityEndDate: '',
            inputStoreHead3: '',
            sh3EffectivityStartDate: '',
            sh3EffectivityEndDate: '',
            inputSiteQuota: '',
            inputCity: '',
            inputZipCode: '',
            inputRegion: '',
            inputLessor: '',
            inputRentArrangement: '',
            inputSecurityDeposit: '',
            inputNavStoreCode: '',
            inputConstructionBond: '',
            inputSiteConcept: '',
            inputStoreCategory: '',
            ipAddress: '',
            inputRemark: '',
            contactNumber: '',
            telephone:'',
            contactPerson: '',
            inputCreatedBy: '',
            inputCreatedAt: '',
            inputUpdatedBy: '',
            inputUpdatedAt: '',
            showDetails: true,
            inputEmail: null,
            checkboxes: {
                isRemote: null,
                isAllowedMergingSales: null,
                canDownloadPosInventory: null,
                // canDownloadPosSitePricing: null,
                // canDownloadTerminalSettings: null,
                isStrickLotCodes: null,
                // isSupportingZippedDocument: null,
                isEnableEcomPos:null,
                isEnableSiteReplication: null,
                isEnableSiteReset: null
            },
            authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
            errors: [],

            // FOR META-DATA
            customFormMode: 1,
            customForm: {},
            profileData: {},
            dynamicFormKey: 0,
            site: {},
            formErrors: [],

            inputSublocationCode: '',
            inputSublocationName: '',
            inputSite: '',
            inputSublocationType: '',
            sublocationTypeOptions: [
                {key: null, value: null},
                {key: "T", value: "Truck"},
                {key: "S", value: "Store-front"},
                {key: "B", value: "Backroom"}
            ],
            salesmanName: '',
            inputSalesman: '',
            inputDescription: '',
            inputTags: '',
            sublocationName: '',
            inputSublocation: '',
            terminalName:'',
            inputTerminal:'',
            inputReplicateSiteId: '',
            disableReplication: false,
            region_code: null,
            region_name: "",
            province_code: null,
            province_name: "",
            city_code: null,
            city_name: "",
            barangay_code: null,
            barangay_name: "",
            country_id: null,
            zip_code: null,
            addressOptions: {
                regions: [],
                provinces: [],
                cities: [],
                barangays: []
            },
            addressLoading: false,
            countries: [],
        }
    },
    filters: {
        dateFilter: function (timestamp) {
            return moment(timestamp).format('L LTS')
        }
    },
    watch:{
        inputLessor: function(params) {
            if (!isNaN(this.inputLessor)){
                this.lessor_id = this.inputLessor
            }
        }
    },
    methods: {
        async handleB2bCustomerSearch(value){
            this.fetching = true;
            if(value == undefined)
              var b2bCustomersList = await HTTPRequest.getRequest(this.endPoint + "b2b_customers" , null, null)
            else
              var b2bCustomersList = await HTTPRequest.getRequest(this.endPoint + "b2b_customers?name=" + value , null, null)

            this.b2bCustomersList = b2bCustomersList.data

            this.fetching = false;
        },
        calculateAge() {
            if (this.storeOpeningDate != null && this.storeClosureDate != null) {
                const startDate = new Date(this.storeOpeningDate);
                const endDate = new Date(this.storeClosureDate)

                // Ensure startDate is before endDate
                if (startDate > endDate) {
                    [startDate, endDate] = [endDate, startDate];
                }

                component_x.inputSiteAge = this.getFormattedAgeDifference(startDate, endDate);
            } else {
                component_x.inputSiteAge = '0 Year, 0 Month, 0 Day';
            }
        },

        getFormattedAgeDifference(startDate, endDate) {
            let years = endDate.getFullYear() - startDate.getFullYear();
            let months = endDate.getMonth() - startDate.getMonth();
            let days = endDate.getDate() - startDate.getDate();

            // Adjust for negative days
            if (days < 0) {
                months--;
                // Get the last day of the previous month
                const lastMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 0);
                days += lastMonth.getDate();
            }

            // Adjust for negative months
            if (months < 0) {
                years--;
                months += 12;
            }

            const yearsDisplay = years > 0 ? years + (years == 1 ? " Year, " : " Years, ") : "";
            const monthsDisplay = months > 0 ? months + (months == 1 ? " Month, " : " Months, ") : "";
            const daysDisplay = days > 0 ? days + (days == 1 ? " Day" : " Days") : "";

            return yearsDisplay + monthsDisplay + daysDisplay;
        },

        filterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        },
        updateSettings(newFormSettings, settingsGrouping, errors){
            var formSettingsCopy = this.site
            var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
            this.formErrors = errors

            if(this.customFormMode == 3) {
                this.errors = errors
            }

            this.site = mergedHash
        },
        isJsonString(str) {
            try {
                var json = JSON.parse(str);
                return (typeof json === 'object');
            } catch (e) {
                return false;
            }
        },
        openDetails() {
            this.showDetails = true
        },
        openHistory() {
            this.showDetails = false
        },
        sublocationEndpoint (input) {
            return this.endPoint + '/sublocations?name=' + input+'&site_id='+component_x.profileId;
        },
        getSublocation (group) {
            this.sublocationName = group.display;
            this.inputSublocation = group.value;
        },
        salesmanEndpoint (input) {
            return this.endPoint + '/salesmen?name=' + input;
        },
        getSalesman (group) {
            this.salesmanName = group.display;
            this.inputSalesman = group.value;
        },
        companyEndpoint (input) {
            return this.endPoint + '/companies?name=' + input;
        },
        brandEndpoint (input) {
            return this.endPoint + '/brands?name=' + input;
        },
        brandCategoryEndpoint (input) {
            return this.endPoint + '/brand_categories?name=' + input;
        },
        siteConceptEndpoint (input) {
            return this.endPoint + '/site_concepts?name=' + input;
        },
        terminalEndpoint (input) {
            return this.endPoint + '/terminals?name=' + input;
        },
        sitesEndpoint(input){
            return this.endPoint + '/sites/get_valid_sites?name=' + input;
        },
        getCompany (group) {
            this.companyName = group.display;
            this.inputCompany = group.value;

            this.setCompanyTin(this.inputCompany)
        },
        getSiteConcept (group) {
            this.siteConceptName = group.display;
            this.inputSiteConcept = group.value;
        },
        getStoreCategory (group) {
            this.storeCategoryName = group.display;
            this.inputStoreCategory = group.value;
        },
        getTerminal (group) {
            console.log(group)
            this.terminalName = group.display;
            this.inputTerminal = group.value;
        },
        getSite(group){
            this.siteName = group.display;
            this.inputReplicateSiteId = group.value;
        },
        siteTypeEndpoint (input) {
            return this.endPoint + '/site_types?name=' + input + '&is_channel=false';
        },
        channelTypeEndpoint(input){
            return this.endPoint + '/site_types?name=' + input + '&is_channel=true';
        },
        mallGroupEndpoint (input) {
            return this.endPoint + '/mall_groups?name=' + input;
        },
        mallEndpoint (input) {
            return this.endPoint + '/malls?name=' + input;
        },
        countryEndpoint (input) {
            return this.endPoint + '/countries?name=' + input;
        },
        getSiteType (group) {
            this.siteTypeName = group.display;
            this.inputSiteType = group.value;
        },
        getChannelType(group) {
            this.channelTypeName = group.display;
            this.inputChannelType = group.value;
        },
        getMallGroup (group) {
            this.mallGroupName = group.display;
            this.inputMallGroup = group.value;
        },
        getMall (group) {
            this.mallName = group.display;
            this.inputMall = group.value;
        },
        getCountry (group) {
            this.countryName = group.display;
            this.inputCountry = group.value;
        },
        formattedDisplay (result) {
          return result.name + ' [' + result.code + ']';
        },
        validateForm(){
            this.errors = [];
            // this.errors.push(ValidateField.required('Site Code', this.inputSiteCode));
            // this.errors.push(ValidateField.alphanumericWithSpecialChars('Site Code', this.inputSiteCode));
            this.errors.push(ValidateField.required('Site Name', this.inputName));
            // this.errors.push(ValidateField.alphanumericWithSpecialChars('Site Name', this.inputName));
            this.errors.push(ValidateField.required('Site Type', this.inputSiteType));
            this.errors.push(ValidateField.required('Mall Group', this.inputMallGroup));
            this.errors.push(ValidateField.required('Mall', this.inputMall));
            this.errors.push(ValidateField.required('Country', this.country_id));
            this.errors.push(ValidateField.required('Province', this.province_code));
            this.errors.push(ValidateField.required('City', this.city_code));
            this.errors.push(ValidateField.required('Zip Code', this.inputZipCode));
            this.errors.push(ValidateField.required('Site Address 1', this.inputAddress));
            this.errors.push(ValidateField.required('Barangay', this.barangay_code));
            this.errors.push(ValidateField.required('Company', this.inputCompany));
            this.errors.push(ValidateField.required('Site Concept', this.inputSiteConcept));
            this.errors.push(ValidateField.required('Store Category', this.inputStoreCategory));
            //this.errors.push(ValidateField.required('Telephone', this.telephone));
            //this.errors.push(ValidateField.required('TIN Number', this.inputTin));
            // this.errors.push(ValidateField.alphanumericWithSpecialChars('TIN Number', this.inputTin));
            this.errors.push(ValidateField.required('TIN Branch Code', this.inputTinBranchCode));
            this.errors.push(ValidateField.alphanumericWithSpecialChars('TIN Branch Code', this.inputTinBranchCode));
            this.errors.push(ValidateField.alphanumericWithNewline('Site Address', this.inputAddress));
            this.errors.push(ValidateField.required('Island', this.inputLocation));
            this.errors.push(ValidateField.required('Viber Number', this.inputViberNumber));
            if(this.inputEmail != null && this.inputEmail != ""){
                this.errors.push(ValidateField.emailFormat('Email', this.inputEmail));
            }

            this.errors.push(ValidateField.decimalFormat('SQM', this.inputSqm));
            this.errors.push(ValidateField.decimalFormat('Basic Rent Per SQM', this.inputBasicRentPerSqm));
            this.errors.push(ValidateField.decimalFormat('Mall Commission', this.inputMallCommission));
            this.errors.push(ValidateField.decimalFormat('MGR', this.inputMgr));
            this.errors.push(ValidateField.decimalFormat('CUSA', this.inputCusa));
            this.errors.push(ValidateField.decimalFormat('Aircon', this.inputAircon));
            this.errors.push(ValidateField.decimalFormat('Store Quota', this.inputSiteQuota));

            if(this.checkboxes.isEnableEcomPos != null && this.checkboxes.isEnableEcomPos != ""){
                this.errors.push(ValidateField.required('Terminal', this.inputTerminal));
            }
            if(this.checkboxes.isEnableSiteReplication != null && this.checkboxes.isEnableSiteReplication != false){
                this.errors.push(ValidateField.required('Site Replication', this.inputReplicateSiteId))
            }
            //this.errors.push(ValidateField.isNull('Support Zipped Document', this.checkboxes.isSupportingZippedDocument));
            if (this.profileId == 0) {
                //this.errors.push(ValidateField.required('Sublocation Name', this.inputSublocationName));
                // this.errors.push(ValidateField.required('Sublocation Code', this.inputSublocationCode));
            }else{
                 this.errors.push(ValidateField.required('Sublocation Name', this.sublocationName));
            }
            this.errors.push(ValidateField.alphanumericWithSpace('Sublocation Description', this.inputDescription));
            this.errors.push(ValidateField.alphanumericWithSpace('Sublocation Tags', this.inputTags));

            this.errors = this._.compact(this.errors);
            document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
            return this.errors.length;
        },
        async setCompanyTin(company_id) {
            var request = await HTTPRequest.getRequest(this.endPoint + '/companies?id=' + company_id)
            
            if (request != null) {
                request.data.map((company) => {
                    if (company.id == company_id) {
                        this.inputTin = company.tin
                    }
                })
            }
        },

        create: async function() {
            //Check if site type is HO >> 1 HO per Company
            //Get HO id
            const ho_site_type = await HTTPRequest.getRequest(this.endPoint + 'site_types?code=ho', null)

            //If selected is ho then check if there is ho site
            if(ho_site_type['data'][0].id == this.inputSiteType && this.inputCompany > 0){
                if(ho_site_type['data'].length > 0){
                    //Get site with HO site type id
                    const site_ho = await HTTPRequest.getRequest(this.endPoint + 'sites?status=A&site_type_id='+ho_site_type['data'][0].id+'&company_id='+this.inputCompany, null)
                    if(site_ho.data.length > 0){
                        this.errors = [];
                        this.errors.push('Company has already HO site type.');
                        return 
                    }
                }
            }
            

            if(!this.validateForm()) {
                var sitePayload = {site: {name: this.inputName.trim(), code: this.inputSiteCode.trim(), refcode: this.inputCode.trim(), location_id: ((this.inputLocation == null) ? null:this.inputLocation[this.inputLocation.length -1]), location_path: JSON.stringify(this.inputLocation),
                                                site_type_id: this.inputSiteType, company_id: this.inputCompany,channel_type_id: this.inputChannelType,
                                                tin: this.inputTin, tin_branch_code: this.inputTinBranchCode, address: this.inputAddress, ip_address: this.ipAddress,
                                                remark: this.inputRemark, contact_person: this.contactPerson,telephone:this.telephone, landline_number: this.contactNumber,
                                                is_remote: this.checkboxes.isRemote,
                                                is_allowed_merging_sales: this.checkboxes.isAllowedMergingSales,
                                                can_download_pos_inventory: this.checkboxes.canDownloadPosInventory,
                                                // can_download_pos_site_pricing: this.checkboxes.canDownloadPosSitePricing,
                                                // can_download_terminal_settings: this.checkboxes.canDownloadTerminalSettings,
                                                is_strick_lot_codes: this.checkboxes.isStrickLotCodes,
                                                is_for_resetting: this.checkboxes.isEnableSiteReset,
                                                // is_supporting_zipped_document: this.checkboxes.isSupportingZippedDocument,
                                                email: this.inputEmail,
                                                ecomm_terminal_id:this.inputTerminal,
                                                replicated_site_id: this.inputReplicateSiteId,
                                                mall_group_id: this.inputMallGroup,
                                                mall_id: this.inputMall,
                                                country_id: this.country_id,
                                                measurement: this.inputSqm,
                                                opening_date: this.storeOpeningDate,
                                                closure_date: this.storeClosureDate,
                                                contract_start_date: this.contractStartDate,
                                                contract_end_date: this.contractEndDate,
                                                address_1: this.inputAddress,
                                                address_2: this.inputAddress2,
                                                basic_rent_per_sqm: this.inputBasicRentPerSqm,
                                                mall_commission: this.inputMallCommission,
                                                mgr: this.inputMgr,
                                                cusa: this.inputCusa,
                                                aircon: this.inputAircon,
                                                contract_link: this.inputContactLink,
                                                telco_provider: this.inputTelcoProvider,
                                                internet_provider: this.inputInternetProvider,
                                                viber_number: this.inputViberNumber,
                                                sec_dep: this.inputSecDep,
                                                area_leader: this.inputAreaHead,
                                                regional_sales_head: this.inputRegionalHead,
                                                store_head1_id: this.inputStoreHead1,
                                                sh1_effectivity_start_date: this.sh1EffectivityStartDate,
                                                sh1_effectivity_end_date: this.sh1EffectivityEndDate,
                                                store_head2_id: this.inputStoreHead2,
                                                sh2_effectivity_start_date: this.sh2EffectivityStartDate,
                                                sh2_effectivity_end_date: this.sh2EffectivityEndDate,
                                                store_head3_id: this.inputStoreHead3,
                                                sh3_effectivity_start_date: this.sh3EffectivityStartDate,
                                                sh3_effectivity_end_date: this.sh3EffectivityEndDate,
                                                site_quota: this.inputSiteQuota,
                                                city: this.inputCity,
                                                zip_code: this.inputZipCode,
                                                region: this.inputRegion,
                                                // lessor: this.inputLessor,
                                                lessor: (this.lessor_id > 0) ? this.lessor_id : this.inputLessor,
                                                rent_arrangement: this.inputRentArrangement,
                                                security_deposit: this.inputSecurityDeposit,
                                                nav_store_code: this.inputNavStoreCode,
                                                construction_bond: this.inputConstructionBond,
                                                site_concept_id: this.inputSiteConcept,
                                                store_category_id: this.inputStoreCategory,
                                                sublocation: {
                                                    name: this.inputSublocationName.trim(), code: this.inputSublocationCode.trim(),
                                                    sublocation_type: this.inputSublocationType, salesman_id: this.inputSalesman,
                                                    description: this.inputDescription, tags: this.inputTags
                                                },
                                                province_code: this.province_code,
                                                province_name: this.province_name,
                                                city_code: this.city_code,
                                                city_name: this.city_name,
                                                barangay_code: this.barangay_code,
                                                barangay_name: this.barangay_name,
                                                site_age: this.inputSiteAge
                                        }
                                    }
                var mergedHash = Object.assign({}, this.site, sitePayload.site);
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'sites', null, {site: mergedHash})
                if(post_request == undefined){
                    this.$emit('refreshPage', event)
                } else {
                    if(post_request["error"] == undefined){
                       this.$emit('refreshPage', event)
                    } else {
                        this.errors = post_request["error"].split(",") //format will change when error message has comma
                        //this.$router.push("/")
                    }
                }
            }
        },
        update: async function(){
            if(!this.validateForm()) {
                var sitePayload = {site: {name: this.inputName.trim(), code: this.inputSiteCode.trim(), refcode: this.inputCode.trim(), location_id: ((this.inputLocation == null) ? null:this.inputLocation[this.inputLocation.length -1]), location_path: JSON.stringify(this.inputLocation),
                                                site_type_id: this.inputSiteType, company_id: this.inputCompany,channel_type_id: this.inputChannelType,
                                                tin: this.inputTin, tin_branch_code: this.inputTinBranchCode, address: this.inputAddress,
                                                remark: this.inputRemark, contact_person: this.contactPerson, telephone:this.telephone, landline_number: this.contactNumber,
                                                is_remote: this.checkboxes.isRemote, ip_address: this.ipAddress,
                                                is_allowed_merging_sales: this.checkboxes.isAllowedMergingSales,
                                                can_download_pos_inventory: this.checkboxes.canDownloadPosInventory,
                                                // can_download_pos_site_pricing: this.checkboxes.canDownloadPosSitePricing,
                                                // can_download_terminal_settings: this.checkboxes.canDownloadTerminalSettings,
                                                is_strick_lot_codes: this.checkboxes.isStrickLotCodes,
                                                is_for_resetting: this.checkboxes.isEnableSiteReset,
                                                // is_supporting_zipped_document: this.checkboxes.isSupportingZippedDocument,
                                                sublocation_id: this.inputSublocation, email: this.inputEmail,
                                                ecomm_terminal_id:this.inputTerminal, replicated_site_id: this.inputReplicateSiteId,
                                                mall_group_id: this.inputMallGroup,
                                                mall_id: this.inputMall,
                                                country_id: this.country_id,
                                                measurement: this.inputSqm,
                                                opening_date: this.storeOpeningDate,
                                                closure_date: this.storeClosureDate,
                                                contract_start_date: this.contractStartDate,
                                                contract_end_date: this.contractEndDate,
                                                address_1: this.inputAddress,
                                                address_2: this.inputAddress2,
                                                basic_rent_per_sqm: this.inputBasicRentPerSqm,
                                                mall_commission: this.inputMallCommission,
                                                mgr: this.inputMgr,
                                                cusa: this.inputCusa,
                                                aircon: this.inputAircon,
                                                contract_link: this.inputContactLink,
                                                telco_provider: this.inputTelcoProvider,
                                                internet_provider: this.inputInternetProvider,
                                                viber_number: this.inputViberNumber,
                                                sec_dep: this.inputSecDep,
                                                area_leader: this.inputAreaHead,
                                                regional_sales_head: this.inputRegionalHead,
                                                store_head1_id: this.inputStoreHead1,
                                                sh1_effectivity_start_date: this.sh1EffectivityStartDate,
                                                sh1_effectivity_end_date: this.sh1EffectivityEndDate,
                                                store_head2_id: this.inputStoreHead2,
                                                sh2_effectivity_start_date: this.sh2EffectivityStartDate,
                                                sh2_effectivity_end_date: this.sh2EffectivityEndDate,
                                                store_head3_id: this.inputStoreHead3,
                                                sh3_effectivity_start_date: this.sh3EffectivityStartDate,
                                                sh3_effectivity_end_date: this.sh3EffectivityEndDate,
                                                site_quota: this.inputSiteQuota,
                                                city: this.inputCity,
                                                zip_code: this.inputZipCode,
                                                region: this.inputRegion,
                                                //lessor: this.inputLessor,
                                                lessor: (this.lessor_id > 0) ? this.lessor_id : this.inputLessor,
                                                rent_arrangement: this.inputRentArrangement,
                                                security_deposit: this.inputSecurityDeposit,
                                                nav_store_code: this.inputNavStoreCode,
                                                construction_bond: this.inputConstructionBond,
                                                site_concept_id: this.inputSiteConcept,
                                                store_category_id: this.inputStoreCategory,
                                                sublocation: {
                                                    name: this.sublocationName
                                                },
                                                province_code: this.province_code,
                                                province_name: this.province_name,
                                                city_code: this.city_code,
                                                city_name: this.city_name,
                                                barangay_code: this.barangay_code,
                                                barangay_name: this.barangay_name,
                                                site_age: this.inputSiteAge
                                        }

                                    }
                // var sitePayload =
                var mergedHash = Object.assign({}, this.site, sitePayload.site);
                // console.log(mergedHash)
                var put_request = await HTTPRequest.putRequest(this.endPoint + 'sites/' + this.profileId, null, {site: mergedHash})
                if(put_request == undefined){
                    this.$emit('refreshPage', event)
                } else {
                    if(put_request["error"] == undefined){
                        this.$emit('refreshPage', event)
                    } else {
                        this.errors = put_request["error"].split(",") //format will change when error message has comma
                        //this.$router.push("/")
                    }
                }
            }
        },
        changeAddress: async function(list, fresh = 0){
            this.addressLoading = true
            switch(list) {
            case 'provinces':
                if(this.country_id != null){
                    await this.getList(list, this.country_id, 'country')
                    this.sort(this.response)
                    this.provinces = this.response
                    this.addressOptions = {
                        provinces: this.provinces,
                        cities: [],
                        barangays: []
                    }
            
                    if(fresh == 0){
                        this.province_code= null
                        this.province_name= ""
                        this.city_code= null
                        this.city_name= ""
                        this.barangay_code= null
                        this.barangay_name= ""
                    } else {
                        if(parseInt(this.province_code) > 0){
                            this.province_code= this.provinces.find(x => x.id === parseInt(this.province_code))['id']
                            this.province_name= this.provinces.find(x => x.id === parseInt(this.province_code))['name']
                        }
                    }
                }
                break;
            case 'cities':
                if(this.country_id != null && this.province_code != null){
                    await this.getList(list, this.province_code, 'province')
                    this.sort(this.response)
                    this.cities = this.response
                    this.addressOptions = {
                        provinces: this.provinces,
                        cities: this.cities,
                        barangays: []
                    }

                    if(fresh == 0){
                        this.city_code= null
                        this.city_name= ""
                        this.barangay_code= null
                        this.barangay_name= ""
                    } else {
                        if(parseInt(this.city_code) > 0){
                            this.city_code= this.cities.find(x => x.id === parseInt(this.city_code))['id']
                            this.city_name= this.cities.find(x => x.id === parseInt(this.city_code))['name']
                        }
                    }
                }
                break;
            case 'barangays':
                if(this.country_id != null && this.province_code != null && this.city_code != null){
                    await this.getList(list, this.city_code, 'city')
                    this.sort(this.response)
                    this.barangays = this.response
                    this.addressOptions = {
                        provinces: this.provinces,
                        cities: this.cities,
                        barangays: this.barangays
                    }

                    if(fresh == 0){
                        this.barangay_code= null
                        this.barangay_name= ""
                    } else {
                        if(parseInt(this.barangay_code) > 0){
                            this.barangay_code= this.barangays.find(x => x.id === parseInt(this.barangay_code))['id']
                            this.barangay_name= this.barangays.find(x => x.id === parseInt(this.barangay_code))['name']
                        }
                    }
                }
                break;
            default:
                if(this.barangay_code != null){
                    Object.assign({
                        barangay_name: this.addressOptions.barangays.find(x => x.id === this.barangay_code).name
                    })
                }

                //Get Zip Code
                // await axios({
                //     method: 'GET',
                //     url: 'https://s.boxme.asia/api/v2/sellers/locations/' + this.country_id + '/zipcodes?province_id=' + this.province_code + '&district_id=' + this.city_code
                // })
                // .then(function (response) {
                //     let response_data = response.data
                //     console.log('^^^^^^^^^^^^^^^^^^^^')
                //     console.log(response_data)
                //     console.log('^^^^^^^^^^^^^^^^^^^^')
                // }).catch(err => {
                //     component_x.response = []
                // })
                }

            this.addressLoading = false
        },
        getList: async function(list, parent_code, parentList){
            component_x = this;

            let code
            if (parent_code == null){
                code = ''
            } else if(parentList == 'country') {
                code = 'get_box_me_' + list + '?' + parentList + '=' + parent_code
            } else if(parentList == 'province') {
                code = 'get_box_me_districts?country=' + this.country_id + '&' + parentList + '_id=' + parent_code
            } else if(parentList == 'city') {
                code = 'get_box_me_sub_districts?country=' + this.country_id + '&province_id=' + this.province_code + '&district_id=' + parent_code
            }

            const result = await HTTPRequest.getRequest(this.endPoint + 'box_me_locations/' + code  , null)
            if(result.length > 0){
                this.errors = [];
                let response_data = result
                let response_array = []
                for (let index = 0; index < response_data.length; index++) {
                    let row_set = response_data[index]
                    response_array.push({
                        id: row_set.id,
                        name: row_set.name
                    })
                }
                component_x.response = response_array
            } else {
                this.errors.push('No '+ list + ' for the selected ' + parentList + '.');
            }
                
        },
        sort(data){
            data.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
        },
    }
}
</script>

<style>
    textarea {
        resize: none;
    }
</style>
